const suitableItems = [
  'Reklamdan gelen kişileri daha düzenli takip etmek isteyen firmalar',
  'Sadece mesaj değil, kaliteli potansiyel müşteri isteyenler',
  'Randevu, kayıt, satış veya teklif sürecini takip etmek isteyenler',
  'Gelen başvuruları panel üzerinden işaretleyebilecek firmalar',
  'Reklam bütçesini daha ölçülebilir kullanmak isteyenler',
  'Satış sürecini otomasyon ve veriyle desteklemek isteyenler',
  'İlk ay sistemi deneyip sonra karar vermek isteyenler',
];

const notSuitableItems = [
  'Sadece en ucuz reklam hizmetini arayanlar',
  'Hiç reklam bütçesi ayırmak istemeyenler',
  'Gelen başvuruları takip etmek istemeyenler',
  'Panelde basit işaretlemeler yapmayacak firmalar',
  'Satış sürecini tamamen başkasına bırakmak isteyenler',
  'Birkaç günde kesin satış garantisi bekleyenler',
  'Sistemi test etmeden doğrudan sonuç bekleyenler',
];

export default function AudienceSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" id="kimler-icin">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-user-star-line text-accent-600 text-lg"></i>
              </div>
              <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">
                Bu Sistem Kimler İçin Uygun?
              </h2>
            </div>
            <ul className="space-y-3">
              {suitableItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </div>
                  <span className="text-foreground-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-foreground-100 flex items-center justify-center">
                <i className="ri-user-unfollow-line text-foreground-500 text-lg"></i>
              </div>
              <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">
                Bu Sistem Kimler İçin Uygun Değil?
              </h2>
            </div>
            <ul className="space-y-3">
              {notSuitableItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-foreground-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-foreground-400 text-xs"></i>
                  </div>
                  <span className="text-foreground-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}